module.exports = __webpack_public_path__ + "img/dribbble-brands.ba23fa7.svg";